<script>
  import MenuTrigger from "$lib/components/MenuTrigger.svelte";
  export let data;

  export let isOpen = false;
</script>

<MenuTrigger {data} on:click {isOpen} />
{#if isOpen}
  <div
    class="w-full h-screen bg-white left-0 sm:relative md:relative lg:absolute"
    style="z-index: 9999; top: 64px;"
  >
    <div class="p-3 flex justify-center">
      <div>
        <slot />
      </div>
    </div>
  </div>
{/if}
